import { Link } from 'react-router-dom';
import WizardContainer from '../components/wizard/WizardContainer';
import './HomePage.css';

export default function HomePage() {
  return (
    <div className="home-page">
      <header className="home-page__header">
        <Link to="/" className="home-page__logo">
          <svg viewBox="0 0 100 100" className="home-page__logo-icon">
            <defs>
              <linearGradient id="headerVibeGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: '#818cf8' }} />
                <stop offset="50%" style={{ stopColor: '#c084fc' }} />
                <stop offset="100%" style={{ stopColor: '#f472b6' }} />
              </linearGradient>
            </defs>
            <rect width="100" height="100" rx="20" fill="currentColor" className="home-page__logo-bg" />
            <path 
              d="M25 70 L40 30 L50 55 L60 30 L75 70" 
              stroke="url(#headerVibeGrad)" 
              strokeWidth="8" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              fill="none"
            />
            <circle cx="50" cy="75" r="6" fill="url(#headerVibeGrad)" />
          </svg>
          <span className="home-page__logo-text">Vibe Link</span>
        </Link>
      </header>

      <main className="home-page__main">
        <div className="home-page__hero">
          <h1 className="home-page__title">
            Define Your <span className="home-page__title-accent">Design Vibe</span>
          </h1>
          <p className="home-page__subtitle">
            Create a shareable brief card that captures your brand's aesthetic preferences — 
            colors, typography, and feel — all in one place.
          </p>
        </div>

        <WizardContainer />
      </main>

      <footer className="home-page__footer">
        <p>Built with care for designers and their clients</p>
        <a href="https://elmar.eu.org/" target="_blank" rel="noopener noreferrer" className="home-page__footer-link">
          elmar.eu.org
        </a>
      </footer>
    </div>
  );
}
